import { useState, useEffect, useCallback } from 'react';

import styles from './ErrorsIcon.module.scss';

export interface IErrorsIconProps {
  className?: string;
  autoHidingTooltip?: 'onHeaderStickOn' | 'onHeaderStickOff';
}

export const ErrorsIconForUntimelyBasic = ({ className, autoHidingTooltip }: IErrorsIconProps) => {
  const [isErrorsTooltipVisible, setIsErrorsTooltipVisible] = useState(false);

  const onScroll = () => {
    const windowOffset = window.scrollY;
    const headerElement = document.querySelector('header');

    if (headerElement) {
      if (
        (windowOffset > headerElement.offsetHeight && autoHidingTooltip === 'onHeaderStickOn') ||
        (windowOffset <= headerElement.offsetHeight && autoHidingTooltip === 'onHeaderStickOff')
      ) {
        setIsErrorsTooltipVisible(false);
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', onScroll);

    return () => window.removeEventListener('scroll', onScroll);
  });

  const handleErrorsIconClick = useCallback(() => setIsErrorsTooltipVisible(prev => !prev), []);

  const errorsTooltipAttributes = {
    ...(isErrorsTooltipVisible && { 'data-visible': true }),
  };

  return (
    <div className={className ? `${styles.Container} ${className}` : styles.Container}>
      <span className={styles.Icon} onClick={handleErrorsIconClick} />
      <div className={styles.ErrorsForUntimelyBasicTooltip} {...errorsTooltipAttributes}>
        <div className={styles.ErrorsTooltipTitle}>КНМ создана несвоевременно: позже, чем 24 часа после начала</div>
      </div>
    </div>
  );
};
